import React from 'react';

function LocationPinSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12 2C8.20316 2 5.125 5.07816 5.125 8.875C5.125 12 8.11981 17.1622 10.9583 21.4413C11.0502 21.58 11.17 21.6998 11.3089 21.7918C11.8849 22.173 12.6599 22.0165 13.0416 21.4415L13.4577 20.8048C16.1652 16.6027 18.875 12 18.875 8.875C18.875 5.07816 15.7968 2 12 2ZM14.25 9C14.25 7.7574 13.2426 6.75 12 6.75C10.7574 6.75 9.75 7.7574 9.75 9C9.75 10.2426 10.7574 11.25 12 11.25C13.2426 11.25 14.25 10.2426 14.25 9Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default LocationPinSolid;
